/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const demandObjectiveListSchema = z.object({
  data: z.array(z.int()),
});
